import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import Side from "../components/Intro"
import SEO from "../components/SEO"

import Tags from "../components/tags"

export default function Contact({
  data: {
    allContentfulTags: { nodes: tags },
  },
}) {
  return (
    <Layout>
      <SEO title="Tags" description="Page for all tags" />
      <Side isOpen={true}>
        <Tags tags={tags} />
      </Side>
    </Layout>
  )
}

export const query = graphql`
  {
    allContentfulTags {
      nodes {
        id
        tagName
        shortDescription {
          shortDescription
        }
        image {
          fixed(height: 245, width: 370) {
            ...GatsbyContentfulFixed
          }
        }
      }
    }
  }
`
